import React from 'react'
import History_comp from '../../components/mobile_view_comp/history/history_comp'
import Cart_one_head from '../../components/mobile_view_comp/cart_one/cart_one_head'

export default function History() {
  return (
    <>
        <div style={{width:'90%' , margin:'auto' ,marginTop:'65px' , marginBottom:'60px'}}>
            <Cart_one_head link='/profile' head='History' />
            <History_comp />
        </div>
    </>
  )
}
